import {
  Item,
  Picker,
  View,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export function UnitsPicker() {
  return (
    <View>
      <Picker
        aria-label="Units"
        name="units"
        labelPosition="side"
        UNSAFE_className="sm:hidden lg:w-auto"
      >
        <Item>Un1</Item>
        <Item>Un1</Item>
        <Item>Un1</Item>
        <Item>Un1</Item>
        <Item>Un1</Item>
      </Picker>
    </View>
  )
}
